import React from 'react';
import { Link } from 'react-router-dom';
import image from "../../../assets/img/shape/content.png";

const video = "https://buildgo-react.vercel.app/static/media/banner.b1e80eca5dee07cccccd.mp4";

const BannerFour = () => {
    return (
        <div className="banner__four">
            <div className="bg-video">
                <video autoPlay muted loop playsInline><source src={video} type="video/mp4" /></video>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="banner__four-content">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".3s">Expert Solutions</span>
                                <h1 className="wow fadeInRight" data-wow-delay=".6s">Shaping Future</h1>
                                <h2 className="wow fadeInRight" data-wow-delay=".9s">Architecture</h2>
                                <div className="wow fadeInDown" data-wow-delay="1.2s">
                                    <Link className="build_button" to="/request-quote">Start Today<i className="flaticon-right-up"></i></Link>
                                </div>
                            <Link to="/request-quote"><img className="h_rotate" src={image} alt="image" /></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerFour;